import { render, staticRenderFns } from "./SleepTime.vue?vue&type=template&id=1cb95f3a&scoped=true"
import script from "./SleepTime.vue?vue&type=script&lang=js"
export * from "./SleepTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb95f3a",
  null
  
)

export default component.exports